const defaultState = {
    loading: false,
    error: false,
	data: [],
};

export default function reducer(state = defaultState, action) {
	switch (action.type) {

		case 'LANGUAGES_FETCH_LANGUAGES_START':
			return Object.assign({}, state, {
                loading: true,
                error: false,
                data: [],
			})

		case 'LANGUAGES_FETCH_LANGUAGES_SUCCESS':
			return Object.assign({}, state, {
				loading: false,
				data: action.payload.languages
			})

		case 'LANGUAGES_FETCH_LANGUAGES_FAILURE':
			return Object.assign({}, state, {
				loading: false,
				error: true,
			})

		default:
			return state;
	}
}
